<ccl-page-header>
    <div class="s-page-header__left c-page-header__left">
        <div class="c-title c-title--secondary">
            Log In Screen
        </div>
    </div>
    <div class="s-page-header__right">
        <ccl-toggle-button
            [title]="loginConfig.isEnabled ? 'Enable' : 'Disable'"
            [isChecked]="loginConfig.isEnabled"
            (isCheckedChange)="toggleLoginEnable($event)"
            >{{ loginConfig.isEnabled ? "Enabled" : "Disabled" }}</ccl-toggle-button
        >
    </div>
</ccl-page-header>

<ccl-content-section *ngIf="loginConfig.isEnabled">
    <div class="login-drawer">
        <div class="c-title--subsection text-uppercase">
            Log In Popup
        </div>
        <div class="row row--builder">
            <div class="col c-box" [class.c-box]="!hoverOut" [class.c-box-nohover]="hoverOut">
                <div
                    class="c-box" title="Edit Login Header"
                    (cclClick)="openConfigDrawer('header', $event, 'header')"
                    (mouseout)="hoverOut = false"
                    (mouseover)="hoverOut = true"
                >
                    <h3
                        class="header"
                        [ngStyle]="{
                            background: loginConfig.header.background
                        }"
                    >
                        <span [ngStyle]="loginFontStyle">
                            {{ loginConfig.header.label }}
                        </span>
                    </h3>
                </div>

                <div class="login-drawer-body">
                    <div class="row">
                        <div class="col-sm-12 col-xs-12">
                            <div class="login-sso-buttons" *ngIf="loginConfig.body.isSSOEnabled">
                                <button
                                    class="c-btn c-btn--primary"
                                    [ngStyle]="{
                                        'background-color': loginConfig.footer.button.primary.background,
                                         color: loginConfig.footer.button.primary.color
                                    }"
                                    *ngFor="let ssoConfig of loginConfig.body.ssoConfigs"
                                    [ngClass]="ssoConfig.ssoAccountConfig.buttonConfig.buttonClass"
                                >
                                    <img role="presentation" src="{{ ssoConfig.ssoAccountConfig.buttonConfig.buttonIcon }}" />
                                    {{ ssoConfig.ssoAccountConfig.buttonConfig.buttonLabel }}
                                </button>
                            </div>
                            <div
                                class="login-body-help  c-box"
                                (mouseout)="hover = false; hoverOut = false"
                                (mouseover)="hover = true; hoverOut = true" title="Edit Info Text"
                                (cclClick)="openConfigDrawer('body_html_text', $event, 'body_html_text')"
                            >
                                <span [innerHTML]="loginConfig.body.help_text | safeHtml"></span>
                            </div>
                            <div
                                class="login-body  c-box"
                                (mouseout)="hover = false; hoverOut = false"
                                (mouseover)="hover = true; hoverOut = true" title="Edit Login Body"
                                (cclClick)="openConfigDrawer('body', $event, 'body')"
                            >
                                <div class="c-form-group">
                                    <input title="{{ loginConfig.body.username }}"
                                        cclFormInput
                                        type="text"
                                        class="c-c-form-group__input form-control"
                                        placeholder="{{ loginConfig.body.username }}"
                                    />
                                    <div class="c-form-group__hint">&nbsp;</div>
                                </div>

                                <div class="c-form-group">
                                    <input title="{{ loginConfig.body.password }}"
                                        cclFormInput
                                        type="password"
                                        class="c-c-form-group__input form-control"
                                        placeholder="{{ loginConfig.body.password }}"
                                    />
                                    <div class="c-form-group__hint">&nbsp;</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="login-drawer-footer">
                    <div class="row row--builder">
                        <div class="col--builder col col-sm-7 col-xs-7">
                            <div
                                class="login-footer-help  c-box"
                                (mouseout)="hover = false; hoverOut = false"
                                (mouseover)="hover = true; hoverOut = true" title="Edit Signup Text"
                                (cclClick)="openConfigDrawer('footer_html_text', $event, 'footer_html_text')"
                            >
                                <span [innerHTML]="loginConfig.footer.help_text | safeHtml"></span>
                            </div>
                        </div>
                        <div class="col--builder col col-sm-5 col-xs-5">
                            <div
                                class="login-footer-button  c-box"
                                (mouseout)="hover = false; hoverOut = false"
                                (mouseover)="hover = true; hoverOut = true" title="Edit Login Button"
                                (cclClick)="openConfigDrawer('button', $event, 'button')"
                            >
                                <button
                                    class="c-btn c-btn--secondary"
                                    [ngStyle]="{
                                        'background-color': loginConfig.footer.button.secondary.background,
                                        color: loginConfig.footer.button.secondary.color
                                    }"
                                    *ngIf="loginConfig.footer.formId != null"
                                >
                                    {{ loginConfig.footer.button.secondary.label }}
                                </button>
                                <button
                                    class="c-btn c-btn--primary"
                                    [ngStyle]="{
                                        'background-color': loginConfig.footer.button.primary.background,
                                        color: loginConfig.footer.button.primary.color
                                    }"
                                >
                                    {{ loginConfig.footer.button.primary.label }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="c-title--subsection text-uppercase">
            Sign-up page form link
        </div>
        <div class="row row--builder">
            <div class="col col--builder">
                <div class="c-box">
                    <div class="c-form-group">
                        <ccl-simple-select ariaLabel="Sign-up page form link"
                            [listOfItems]="forms"
                            (valueChange)="changeForm($event.value); loginConfig.footer.formId = $event.value"
                            [value]="loginConfig.footer.formId"
                            [bindValue]="'id'"
                            [bindLabel]="'name'"
                        ></ccl-simple-select>
                        <div class="c-form-group__hint">&nbsp;</div>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
    </div>
</ccl-content-section>

<!-- SESSION EXPIRED CONFIGURATION SECTION WITH LOGIN POPUP SCREEN -->
<ccl-content-section >
    <div class="session-expired-drawer">
        <!-- Session Expires Pop up configuration -->
        <div class="c-title--subsection text-uppercase">
            Session Expired Popup
        </div>

        <!-- Design session expired admin confiurable settings with catalog admin view -->
        <div class="row row--builder">
            <div class="col c-box" [class.c-box]="!hoverOut" [class.c-box-nohover]="hoverOut">
                <div
                    class="c-box" title="Edit Session Expired Header"
                    (cclClick)="openConfigDrawer('session_expired_header', $event, 'session_expired_header')"
                    (mouseout)="hoverOut = false"
                    (mouseover)="hoverOut = true"
                >
                    <h3
                        class="header"
                        [ngStyle]="{
                            background: loginConfig.sessionExpiredConfig.header.background
                        }"
                    >
                        <span [ngStyle]="loginFontStyle">
                            {{ loginConfig.sessionExpiredConfig.header.label }}
                        </span>
                    </h3>
                </div>

                <div class="session-expired-drawer-body">
                    <div class="row">
                        <div class="col-sm-12 col-xs-12">
                            <div
                                class="session-expired-body-help  c-box"
                                (mouseout)="hover = false; hoverOut = false"
                                (mouseover)="hover = true; hoverOut = true" title="Edit Info Text"
                                (cclClick)="openConfigDrawer('session_expired_body', $event, 'session_expired_body')"
                            >
                                <span [innerHTML]="loginConfig.sessionExpiredConfig.body.text | safeHtml"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="session-expired-drawer-footer">
                    <div class="row row--builder">
                        <div class="col--builder col col-sm-12 col-xs-12">
                            <div
                                class="session-expired-footer-button  c-box"
                                (mouseout)="hover = false; hoverOut = false"
                                (mouseover)="hover = true; hoverOut = true" title="Edit Session Expired Button"
                                (cclClick)="openConfigDrawer('session_expired_button', $event, 'session_expired_button')"
                            >
                                <button
                                    class="c-btn c-btn--primary"
                                    [ngStyle]="{
                                        'background-color': loginConfig.sessionExpiredConfig.footer.button.primary.background,
                                        color: loginConfig.sessionExpiredConfig.footer.button.primary.color
                                    }"
                                    *ngIf="loginConfig.sessionExpiredConfig.footer.button.primary.isPrimaryEnabled"
                                >
                                    {{ loginConfig.sessionExpiredConfig.footer.button.primary.label }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="row row--builder">
            <div class="col col--builder">
                <div class="c-box">
                    <div class="c-form-group">
                        <ccl-simple-select ariaLabel="Sesssion expires config"
                            [listOfItems]="sessionExpiredOptions"
                            (valueChange)="changeSessionExpireConfig($event.value);"
                            [value]="loginConfig.footer.sessionExpireConfig"
                            [bindValue]="'id'"
                            [bindLabel]="'name'"
                        ></ccl-simple-select>
                        <div class="c-form-group__hint">&nbsp;</div>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div> -->
    </div>
</ccl-content-section>
